const KEY = 'view_mode';

export const getViewMode = () =>
  localStorage.getItem(KEY) === 'worker' ? 'worker' : 'manager';

export const setViewMode = (mode) =>
  localStorage.setItem(KEY, mode === 'worker' ? 'worker' : 'manager');

export const clearViewMode = () => localStorage.removeItem(KEY);

// A manager/admin can drop into field view only when their login is
// linked to an employee record (the JWT carries employee_id). Without
// the link there is no "self" for the worker screens to resolve.
export const getEffectiveRole = (user, viewMode = getViewMode()) => {
  const role = user?.role || 'manager';
  if (role === 'worker') return 'worker';
  return viewMode === 'worker' && user?.employee_id ? 'worker' : role;
};
